import React from 'react';

import MainContainer from 'containers/Main';

export default function Home() {
  return <MainContainer />;
}
